<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Campaigns</h2>
      <div>
        <base-search-input v-model="filter" class="mr-4" />

        <base-button @click="addOpen = !addOpen">
          <span v-if="addOpen">Close</span>
          <span v-else><icon-plus /> Add campaign</span>
        </base-button>
      </div>
    </div>

    <AdminSegmentCampaignsForm v-if="addOpen" @saved="addOpen = false" />

    <div v-if="fetchingList" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <base-notice v-else-if="empty" class="my-12">
      No campaigns were created yet
    </base-notice>
    <base-notice v-else-if="list.length === 0" class="my-12">
      No matching campaigns
    </base-notice>
    <ul v-else class="my-12">
      <li v-for="campaign in list" :key="campaign.id">
        <div class="flex justify-between bg-white mb-1">
          <div class="py-2 px-4">{{ campaign.name }}</div>
          <base-button @click="campaign.editing = !campaign.editing">
            <icon-edit />
          </base-button>
        </div>
        <AdminSegmentCampaignsForm
          v-if="campaign.editing"
          :campaign="campaign"
          @saved="campaign.editing = false"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { computed, ref } from '@vue/composition-api';
import { useFilterable } from '@/composables/useFilterable';
import AdminSegmentCampaignsForm from './components/AdminSegmentCampaignsForm';

export default {
  components: {
    AdminSegmentCampaignsForm,
  },
  setup(props, { root }) {
    const addOpen = ref(false);
    const filter = ref('');
    const list = computed(
      () => root.$store.state.company.segment.campaign.list
    );
    const filteredList = useFilterable({
      listRef: list,
      key: 'name',
      filterRef: filter,
    });

    return {
      addOpen,
      list: filteredList,
      filter,
    };
  },
  computed: {
    ...mapState('company/segment/campaign', ['fetchingList']),
    ...mapGetters('company/segment/campaign', ['empty']),
  },
};
</script>
